import gql from 'graphql-tag';
import * as React from 'react';
import { compose, graphql } from 'react-apollo';

import Form from '../components/FormGenerator/Form';
import { passwordFields } from '../formFields';
import { Button, Section, Title } from '../modules/modules';
import FlashStore from '../services/FlashStore';
import UserWrap from '../components/UserWrap';
import { url } from '../config';
import CountryService from '../services/CountryService';
import { callAuthorizeBackend } from '../helpers/backend/callAuthorizeBackend';

interface IExportPriceListState {
  generating: boolean;
}

interface IExportPriceListProps {
  userToken?: any;
}

class ExportPriceList extends React.Component<IExportPriceListProps, IExportPriceListState> {

  constructor(props: IExportPriceListProps) {
    super(props);

    this.state = {
      generating: false,
    };

    this.handleSend = this.handleSend.bind(this);
  }

  private handleSend() {
    // volání backendu
    this.setState(
      {
        generating: true,
      },
      () => {
        callAuthorizeBackend({
          path: '/products/pricelist/b2b',
          data: {
            currency: CountryService.GetInstance().currencyCode,
            vatRate: CountryService.GetInstance().VATrate,
          },
          method: 'POST',
          executeDownload: true,
          onSuccess: () => {
            this.setState({
              generating: false,
            });
          },
          onError: () => {
            this.setState({
              generating: false,
            });
          },
        });
      },
    );
  }

  public render() {
    const userToken = this.props.userToken;
    return (
      <main>
        <Section type="userPage">
          <UserWrap>

            <div className="form">
              <Title type="lower">Pricelist</Title>
              {!userToken.loading && userToken.userInfo && userToken.userInfo.jsonPricesDownloadToken && <React.Fragment>
                <div className="form form--userData">
                  <h4>JSON API</h4>
                  <textarea
                    disabled={true}
                    style={{width: '100%'}}
                    rows={5}
                    value={`${
                      url
                    }/products/pricelist/json?currency=${
                      CountryService.GetInstance().currencyCode
                    }&email=${
                      userToken.userInfo.email
                    }&token=${
                      userToken.userInfo.jsonPricesDownloadToken
                    }`}
                  />
                </div>
              </React.Fragment>
              || ''}
              <div className="form form--userData">
                <Button
                  type="xl"
                  disabled={this.state.generating}
                  onClick={() => {
                    this.handleSend();
                  }}
                  style={{marginTop: '0.1em'}}
                >
                  Download XLS
                </Button>
              </div>
            </div>

          </UserWrap>
        </Section>
      </main>
    );
  }
}

const GetJSONPriceListDownloadTokenQuery = gql`
  query UserDataUserInfo {
    userInfo {
      id
      email
      jsonPricesDownloadToken
    }
  }
`;

export default compose(
  graphql<any, any>(GetJSONPriceListDownloadTokenQuery, {
    name: 'userToken'
  })
)(ExportPriceList);



// WEBPACK FOOTER //
// ./src/pages/ExportPriceList.tsx